import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import Navbar from "../components/Navbar";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default function Account() {
  const { user, subscription, getToken } = useAuth();
  const { lang, langCode, switchLang } = useLang();
  const L = lang.account;
  const [name, setName] = useState(user?.name || "");
  const [saved, setSaved] = useState(false);
  const [payments, setPayments] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [paymentsLoaded, setPaymentsLoaded] = useState(false);

  const handleSave = async () => {
    try {
      await fetch(`${API}/api/auth/me`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({ name, lang: langCode }),
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch { }
  };

  const loadPayments = async () => {
    if (paymentsLoaded) return;
    setLoadingPayments(true);
    try {
      const res = await fetch(`${API}/api/payments/history`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (res.ok) {
        const data = await res.json();
        setPayments(data);
        setPaymentsLoaded(true);
      }
    } catch { }
    finally { setLoadingPayments(false); }
  };

  useState(() => { loadPayments(); }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <Navbar />
      <div style={{ maxWidth: 600, margin: "0 auto", padding: "24px 16px" }}>

        <h1 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 24px", fontFamily: "Georgia, serif" }}>{L.title}</h1>

        {/* Profile */}
        <div style={{ background: "#fff", border: "0.5px solid #e5e7eb", borderRadius: 10, padding: "20px 22px", marginBottom: 16 }}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 5, fontFamily: "sans-serif" }}>{L.labelName}</label>
            <input value={name} onChange={e => setName(e.target.value)}
              style={{ width: "100%", boxSizing: "border-box", padding: "9px 12px", border: "0.5px solid #d1d5db", borderRadius: 8, fontSize: 14, fontFamily: "sans-serif" }} />
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 5, fontFamily: "sans-serif" }}>{L.labelEmail}</label>
            <input value={user?.email || ""} disabled
              style={{ width: "100%", boxSizing: "border-box", padding: "9px 12px", border: "0.5px solid #e5e7eb", borderRadius: 8, fontSize: 14, fontFamily: "sans-serif", background: "#f9fafb", color: "#9ca3af" }} />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 8, fontFamily: "sans-serif" }}>{L.labelLang}</label>
            <div style={{ display: "flex", gap: 8 }}>
              {["ro", "en"].map(code => (
                <button key={code} onClick={() => switchLang(code)}
                  style={{ padding: "7px 18px", border: "0.5px solid #d1d5db", borderRadius: 8, background: langCode === code ? "#1d4ed8" : "#fff", color: langCode === code ? "#fff" : "#374151", fontSize: 13, fontWeight: langCode === code ? 600 : 400, cursor: "pointer", fontFamily: "sans-serif" }}>
                  {code === "ro" ? "Română" : "English"}
                </button>
              ))}
            </div>
          </div>

          <button onClick={handleSave}
            style={{ padding: "9px 20px", background: saved ? "#059669" : "#1d4ed8", color: "#fff", border: "none", borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "sans-serif", transition: "background 0.2s" }}>
            {saved ? L.btnSaved : L.btnSave}
          </button>
        </div>

        {/* Subscription */}
        <div style={{ background: "#fff", border: "0.5px solid #e5e7eb", borderRadius: 10, padding: "20px 22px", marginBottom: 16 }}>
          <p style={{ fontSize: 14, fontWeight: 600, margin: "0 0 14px", fontFamily: "sans-serif" }}>{L.labelPlan}</p>

          {subscription ? (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              {[
                [L.labelPlan,    subscription.tier.replace(/_/g, " ")],
                [L.labelReports, `${subscription.reports_used} / ${subscription.reports_total}`],
                [L.labelExpires, subscription.expires_at ? new Date(subscription.expires_at).toLocaleDateString("ro-RO") : "–"],
              ].map(([lbl, val]) => (
                <div key={lbl} style={{ background: "#f9fafb", borderRadius: 8, padding: "10px 12px" }}>
                  <p style={{ fontSize: 11, color: "#9ca3af", margin: "0 0 3px", fontFamily: "sans-serif", textTransform: "uppercase" }}>{lbl}</p>
                  <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", margin: 0, fontFamily: "sans-serif" }}>{val}</p>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ fontSize: 13, color: "#9ca3af", margin: 0, fontFamily: "sans-serif" }}>{lang.dashboard.noPlan}</p>
          )}
        </div>

        {/* Payment history */}
        <div style={{ background: "#fff", border: "0.5px solid #e5e7eb", borderRadius: 10, padding: "20px 22px" }}>
          <p style={{ fontSize: 14, fontWeight: 600, margin: "0 0 14px", fontFamily: "sans-serif" }}>{L.historyTitle}</p>

          {loadingPayments && (
            <p style={{ fontSize: 13, color: "#9ca3af", fontFamily: "sans-serif" }}>{lang.common.loading}</p>
          )}

          {!loadingPayments && payments.length === 0 && (
            <p style={{ fontSize: 13, color: "#9ca3af", margin: 0, fontFamily: "sans-serif" }}>{L.noPayments}</p>
          )}

          {payments.map(p => (
            <div key={p.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "0.5px solid #f3f4f6" }}>
              <div>
                <p style={{ fontSize: 13, fontWeight: 500, margin: "0 0 2px", fontFamily: "sans-serif" }}>{p.tier?.replace(/_/g, " ")} · {p.type}</p>
                <p style={{ fontSize: 11, color: "#9ca3af", margin: 0, fontFamily: "sans-serif" }}>
                  {new Date(p.created_at).toLocaleDateString("ro-RO")} · {p.provider}
                </p>
              </div>
              <div style={{ textAlign: "right" }}>
                <p style={{ fontSize: 14, fontWeight: 700, color: "#374151", margin: "0 0 2px", fontFamily: "sans-serif" }}>{p.amount} {p.currency}</p>
                <span style={{ fontSize: 11, background: p.status === "completed" ? "#d1fae5" : "#fee2e2", color: p.status === "completed" ? "#059669" : "#dc2626", padding: "2px 8px", borderRadius: 8, fontFamily: "sans-serif" }}>
                  {p.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}